<div class="carousel-container">
  <button mat-icon-button class="close-button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="navigation-button prev-button" (click)="prevImage()">
    <mat-icon>chevron_left</mat-icon>
  </div>

  <owl-carousel-o [options]="LogoSlider" #carousel>
    <ng-container *ngFor="let item of images">
      <ng-template carouselSlide>
        <div style="width: 100%;">
          <img [src]="serverPath1 + item.imageName" />
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>

  <div class="navigation-button next-button" (click)="nextImage()">
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>

  


